import { NotFoundPage } from './components/404/404.component';
import { AuxUrlComponent } from './components/auxUrl/auxUrl.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { TramitesComponent } from './components/tramites/tramites.component';
import { InstructionsComponent } from './components/instructions/instructions.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { TopMenuComponent } from './components/menu/top-menu/topmenu.component';
import { routing, appRoutingProviders } from './app.routing';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { MenuComponent } from './components/menu/menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { TabsComponent } from './components/formulario/tabs/tabs.component';
import { FileUploadModule } from 'ng2-file-upload';
import { EscapeHtmlPipe } from './pipes/keep-html.pipe';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { BorradoresComponent } from './components/borradores/borradores.component';
import { NgxPaginationModule } from 'ngx-pagination'; 
import { CommonModule } from '@angular/common';
import { Ng2Rut } from 'ng2-rut';
import { HttpClientModule } from '@angular/common/http'; 


import { SeguimientoCertificadosComponent } from './components/seguimiento-certificados/seguimiento-certificados.component';

//ArcWizard
import { ArchwizardModule } from 'angular-archwizard';
import { NavbarModule } from './components/navbar/navbar.module';
import { RegistroComponent } from './components/home/registro/registro.component';
 
import { ToastrModule } from 'ngx-toastr';
//Angular material
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
  MAT_DATE_LOCALE,
} from '@angular/material';
import { OptionFormComponent } from './components/option-form/option-form.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './app.effects';
import { formReducer } from './reducers/forms.reducer';
import { notificationReducer } from './reducers/notification.recuder';

import { FilterPipe2 } from './pipes/filter.pipe2';
import { NgxSpinnerModule } from 'ngx-spinner';

import { TakePhotoComponent } from './components/perfil/takePhoto/takePhoto.component';
import { CertificadosComponent } from './components/certificados/certificados.component';
import { SolicitudesExpComponent } from 'src/app/components/solicitudesexp/solicitudesexp.component';

import { Navbar_certComponent } from './components/certificados/navbar_cert/navbar_cert.component';
import { Navbar_certModule } from './components/certificados/navbar_cert/navbar_cert.module';
import { LottieAnimationViewModule } from 'ng-lottie';
import { SidenavService } from './services/sidenav.service';
import { BorradorStorageService} from './services/borrador-storage.service'
import { crearBorradorComponent } from './components/borradores/crearBorrador/crearBorrador.component';
import { NgxdModule } from '@ngxd/core';
import { ItemsComponent } from './components/items/items.component';
import { AuxUrlcertComponent } from './components/auxUrlcert/auxUrlcert.component';

//SEGUIMIENTO EXPEDIENTE
import { SeguimientoExpedienteComponent } from './components/seguimiento-expediente/seguimiento-expediente.component';
import { Seguimiento_expedienteComponent } from './components/seguimiento_expediente/seguimiento_expediente.component';
import { Acta_expedienteComponent } from './components/seguimiento_expediente/acta_expediente/acta_expediente.component';
import { Nl2BrPipeModule } from 'nl2br-pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { PresentacionComponent } from './components/presentacion/presentacion.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { finalFormReducer } from './reducers/form_final.reducer';
import { ForgotPassComponent } from './components/home/forgot-pass/forgot-pass.component';
import { AuxUrlInfTerComponent } from './components/aux-url-inf-ter/aux-url-inf-ter.component';
import { MesonOnlineComponent } from './components/meson-online/meson-online.component';

// SEGUIMIENTO DE CERTIFICADOS
import { Seguimiento_certificadoComponent } from './components/seguimiento_certificado/seguimiento_certificado.component';
import { Solicitud_certificadosComponent } from './components/solicitud_certificados/solicitud_certificados.component';

//inspeccion
import { CrearInspeccionComponent } from './components/inspeccion/crear-inspeccion/crear-inspeccion.component';
//import { InspeccionRoutingModule } from './components/inspeccion/inspeccion.routing';
import { SeguimientoInspeccionComponent } from './components/inspeccion/seguimiento-inspeccion/seguimiento-inspeccion.component';
import { SolicitanteInspComponent } from './components/inspeccion/crear-inspeccion/solicitante-insp/solicitante-insp.component';
import { DireccionInspComponent } from './components/inspeccion/crear-inspeccion/direccion-insp/direccion-insp.component';
import { IngresosInspComponent } from './components/inspeccion/crear-inspeccion/ingresos-insp/ingresos-insp.component';
import { DocumentosInspComponent } from './components/inspeccion/crear-inspeccion/documentos-insp/documentos-insp.component';
import { ResumenInspComponent } from './components/inspeccion/crear-inspeccion/resumen-insp/resumen-insp.component';
import { AuxUrlInspeccionComponent } from './components/aux-url-inspeccion/aux-url-inspeccion.component';

//totem
import { TotemBusquedaDireccionComponent } from './components/totem-busqueda-direccion/totem-busqueda-direccion.component';
import { AuxTotemComponent } from './components/auxTotem/auxTotem.component';
import { ValidarCertificadosComponent } from './components/validar-certificados/validar-certificados.component';
import { ValidarDocumentosComponent } from './components/validar-documentos/validar-documentos.component';
import { ClaveUnicaButtonComponent } from './components/clave_unica_button/clave_unica_button.component';
import { ClaveUnicaComponent } from './components/home/claveunica/claveunica.component';

@NgModule({
  declarations: [
    ForgotPassComponent,
    ItemsComponent,
    EscapeHtmlPipe,
    OrderByPipe,
    AppComponent,
    HomeComponent,
    MenuComponent,
    TopMenuComponent,
    TramitesComponent,
    ClaveUnicaButtonComponent,
    ClaveUnicaComponent,
    TabsComponent,
    NavbarComponent,
    CertificadosComponent,
    InstructionsComponent,
    MainNavComponent,
    BorradoresComponent,
    OptionFormComponent,
    RegistroComponent,
    InicioComponent,
    FilterPipe2,
    PerfilComponent,
    TakePhotoComponent,
    AuxUrlComponent,
    AuxUrlcertComponent,
    SolicitudesExpComponent,
    Navbar_certComponent,
    NotFoundPage,
    crearBorradorComponent,
    Seguimiento_expedienteComponent,
    Acta_expedienteComponent,
    PresentacionComponent,
    AuxUrlInfTerComponent,
    MesonOnlineComponent,
    Seguimiento_certificadoComponent,
    Solicitud_certificadosComponent,
    SeguimientoCertificadosComponent,
    SeguimientoExpedienteComponent,
    Solicitud_certificadosComponent,
    ValidarCertificadosComponent,
    ValidarDocumentosComponent,
    CrearInspeccionComponent,
    //InspeccionRoutingModule,
    SeguimientoInspeccionComponent,
    SolicitanteInspComponent,
    DireccionInspComponent,
    IngresosInspComponent,
    DocumentosInspComponent,
    ResumenInspComponent,
    AuxUrlInspeccionComponent,
    TotemBusquedaDireccionComponent,
    AuxTotemComponent
  ],
  imports: [
    BrowserModule,
    Ng2Rut,
    NgxPaginationModule,
    Nl2BrPipeModule,
    routing,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FileUploadModule,
    ArchwizardModule,
    CommonModule,
    NavbarModule,
    Navbar_certModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxSpinnerModule,
    HttpClientModule,
    LottieAnimationViewModule.forRoot(),
    StoreModule.forRoot({form:formReducer, contador: notificationReducer, formFinal: finalFormReducer}),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    EffectsModule.forRoot([AppEffects]),
    ToastrModule.forRoot(),
    NgxdModule
  ],
  entryComponents: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    TramitesComponent,
    TopMenuComponent,
    InstructionsComponent,
    TabsComponent,
    BorradoresComponent,
    OptionFormComponent,
    RegistroComponent,
    InicioComponent,
    PerfilComponent,
    TakePhotoComponent,
    AuxUrlComponent,
    AuxUrlcertComponent,
    CertificadosComponent,
    SolicitudesExpComponent,
    Navbar_certComponent,
    NotFoundPage,
    crearBorradorComponent,
    Seguimiento_expedienteComponent,
    Acta_expedienteComponent,
    AuxUrlInfTerComponent,
    MesonOnlineComponent,
    Seguimiento_certificadoComponent,
    SeguimientoExpedienteComponent,
    Solicitud_certificadosComponent,
    CrearInspeccionComponent,
    //InspeccionRoutingModule,
    SeguimientoInspeccionComponent,
    SolicitanteInspComponent,
    DireccionInspComponent,
    IngresosInspComponent,
    DocumentosInspComponent,
    ResumenInspComponent,
    AuxUrlInspeccionComponent,
    TotemBusquedaDireccionComponent,
    AuxTotemComponent
    
    ],
  providers: [appRoutingProviders,
            {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
          SidenavService,
          BorradorStorageService  
        ],
  bootstrap: [AppComponent]
})
export class AppModule { }
